module.exports = __webpack_public_path__ + "img/settings-button.13c32400.svg";